import { memo } from 'react';
import { MecImage } from '@adapters/bigcommerce/types/product';
import ProductSlider from '@components/product/ProductSlider';
import { FEATURE_FLAG_PDP_IMAGE_GALLERY } from '@config/feature-flag';
import { usePdp } from '@context/PdpContext';
import ImageGallery from '_components/ImageGallery';

interface PdpMediaRendererProps {
  imageGallery: MecImage[];
  madeInCanada?: boolean;
  isCanadianBrand?: boolean;
}

const PdpMediaRenderer = ({
  imageGallery,
  madeInCanada = false,
  isCanadianBrand = false,
}: PdpMediaRendererProps) => {
  const { selectedColour } = usePdp();

  if (FEATURE_FLAG_PDP_IMAGE_GALLERY) {
    return (
      <ImageGallery
        images={imageGallery}
        colourFilterName={selectedColour?.name}
        isMadeInCanada={madeInCanada}
        isCanadianBrand={isCanadianBrand}
      />
    );
  }

  return (
    // TODO: Remove the legacy ProductSlider (react-zoom-pan-pinch v1) path by 2026-06-30.
    <ProductSlider
      imageGallery={imageGallery}
      madeInCanada={madeInCanada}
      isCanadianBrand={isCanadianBrand}
    />
  );
};

export default memo(PdpMediaRenderer);
